<div class="filter-container">
  <!-- Days Checkboxes -->
  <div class="filter-group">
    <label>Days:</label>
    <div *ngFor="let day of days"><input type="checkbox" [value]="day" [checked]="selectedDays.includes(day)" (change)="toggleDay(day, $event)" /> {{ day }}</div>
  </div>

  <!-- Status Radio Buttons -->
  <div class="filter-group">
    <label>Status:</label>
    <div class="d-flex justify-content-around">
      <div class="d-flex"><input type="radio" name="status" value="yes" [(ngModel)]="selectedStatus" /> Attended</div>
      <div class="d-flex"><input type="radio" name="status" value="no" [(ngModel)]="selectedStatus" /> Missed</div>
    </div>
  </div>

  <!-- Submit Button -->
  <button (click)="applyFilter()" [disabled]="!selectedDays.length">Submit</button>
</div>
